import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isClientUser, isBeneficiaryUser, getClientIdFromEmail } from '../utils/userRole';
import { db } from '../firebase';

/**
 * Route protégée pour les clients - redirige vers le dashboard client si c'est un client
 * ou vers la page appropriée si ce n'est pas un client
 */
function ClientRoute({ user, children }) {
  const [isClient, setIsClient] = useState(null);

  useEffect(() => {
    const checkClientStatus = async () => {
      if (!user) {
        setIsClient(false);
        return;
      }

      // Vérifier l'ancienne méthode (email avec préfixe client_)
      if (isClientUser(user.email)) {
        setIsClient(true);
        return;
      }

      // Vérifier le nouveau système (bénéficiaire)
      const isBeneficiary = await isBeneficiaryUser(db, user.uid);
      setIsClient(isBeneficiary);
    };

    checkClientStatus();
  }, [user]);

  // Afficher un loader pendant la vérification
  if (isClient === null) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Si c'est un client ou bénéficiaire, lui permettre d'accéder aux routes client
  if (isClient) {
    return children;
  }

  // Si ce n'est pas un client, rediriger vers le dashboard principal
  return <Navigate to="/dashboard" />;
}

export default ClientRoute;
